<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <div class="kgr-grid kgr-grid--columnGutters">
            <div
                v-if="isDepartmentViewable"
                :class="showDepartmentFullscreen"
            >
                <kgr-member-departments-data-provider
                    v-slot="departmentsScope"
                    :member-id="memberId"
                >
                    <div class="animated fadeIn">
                        <kgr-member-department-relations-form
                            :department-member-relations="departmentsScope.data[0]"
                            :member-id="memberId"
                            :club-id="clubId"
                            :error="error"
                            :is-editable="isDepartmentEditable"
                            :is-creatable="isDepartmentCreatable"
                            :is-deletable="isDepartmentDeletable"
                            @updated="onUpdate(departmentsScope.reload)"
                        />
                    </div>
                </kgr-member-departments-data-provider>
            </div>
            <div
                v-if="isTeamViewable && isDepartmentViewable"
                class="kr-grid_cell kgr-grid__cell--1of12"
            ></div>
            <div
                v-if="isTeamViewable"
                :class="showTeamFullscreen"
            >
                <kgr-member-teams-data-provider
                    v-slot="teamScope"
                    :member-id="memberId"
                >
                    <div class="animated fadeIn">
                        <kgr-member-team-relations-form
                            :team-member-relations="teamScope.data"
                            :member-id="memberId"
                            :club-id="clubId"
                            :error="error"
                            :is-editable="isTeamEditable"
                            :is-creatable="isTeamCreatable"
                            :is-deletable="isTeamDeletable"
                            @updated="onUpdate(teamScope.reload)"
                        />
                    </div>
                </kgr-member-teams-data-provider>
            </div>
            <div
                v-if="isTeamViewable && isDepartmentViewable"
                class="kr-grid_cell kgr-grid__cell--1of12"
            ></div>
        </div>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import KgrMemberDepartmentRelationsForm from '../../components/members/MemberDepartmentRelationsForm.vue';
import KgrMemberTeamRelationsForm from '../../components/members/MemberTeamRelationsForm.vue';
import MemberDepartmentsDataProvider from '../../components/data-provider/MemberDepartmentsDataProvider.vue';
import MemberTeamsDataProvider from '../../components/data-provider/MemberTeamsDataProvider.vue';

export default {
    name: 'KgrMemberDepartmentsAndTeams',
    components: {
        KgrMemberDepartmentRelationsForm,
        KgrMemberTeamRelationsForm,
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-departments-data-provider': MemberDepartmentsDataProvider,
        'kgr-member-teams-data-provider': MemberTeamsDataProvider,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        isDepartmentViewable: {
            type: Boolean,
            required: true,
        },
        isDepartmentEditable: {
            type: Boolean,
            required: true,
        },
        isDepartmentCreatable: {
            type: Boolean,
            required: true,
        },
        isDepartmentDeletable: {
            type: Boolean,
            required: true,
        },
        isTeamViewable: {
            type: Boolean,
            required: true,
        },
        isTeamEditable: {
            type: Boolean,
            required: true,
        },
        isTeamCreatable: {
            type: Boolean,
            required: true,
        },
        isTeamDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
        };
    },
    computed: {
        showDepartmentFullscreen() {
            return this.isTeamViewable ? 'kr-grid_cell kgr-grid__cell--5of12' : 'kr-grid_cell kgr-grid__cell--12of12';
        },
        showTeamFullscreen() {
            return this.isDepartmentViewable ? 'kr-grid_cell kgr-grid__cell--5of12' : 'kr-grid_cell kgr-grid__cell--12of12';
        },
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onUpdate(reload) {
            reload();
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
